'use strict';

module.exports = function (element) {
    let elementOffset;
    if (element && element.find('.is-invalid').length > 0) {
        if (element && element.find('#cardNumber').length && element && element.find('.is-invalid').length) {
            elementOffset = element && element.find('#cardNumber') && element.find('#cardNumber').offset().top;
        } else {
            elementOffset = element && element.find('.is-invalid') && element.find('.is-invalid').offset().top;
        }
    } else if (element && element.find('.is-invalid') && element.find('.is-invalid').length === 0) {
        elementOffset = element.offset().top;
    } else {
        elementOffset = 0;
    }

    var headerHeight = $('header.simplified').height() + 70;
    var totalValue = elementOffset - headerHeight;
    var position = elementOffset ? totalValue : 0;
    $('html, body').animate({
        scrollTop: position
    }, 500);
    if (!element) {
        $('.logo-home').focus();
    }
};
